import { courseApi } from "./index";

export interface CourseRegistrationsListParams {
  ids?: Array<string>;
  companyId?: string;
  courseIds?: Array<string>;
  courseEnabled?: boolean;
  studentIds?: Array<string>;
  studentUserIds?: Array<string>;
  studentName?: string;
  statuses?: Array<"learning" | "pause" | "success" | "fail" | "abort">;
  startedAtMin?: Date;
  startedAtMax?: Date;
  finishedAtMin?: Date;
  finishedAtMax?: Date;
  createdAtMin?: Date;
  createdAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "startedAt" | "finishedAt" | "createdAt" | "studentName";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: CourseRegistrationsListParams, options?: any) => {
  return courseApi.CourseRegistration.listCourseRegistrations(
    params.ids,
    params.companyId,
    params.courseIds,
    params.courseEnabled,
    params.studentIds,
    params.studentUserIds,
    params.studentName,
    params.statuses,
    params.startedAtMin,
    params.startedAtMax,
    params.finishedAtMin,
    params.finishedAtMax,
    params.createdAtMin,
    params.createdAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    options
  );
};
